<template>
	<div style="height: 100%; position: relative;">
		<div
			id="d004"
			class=""
			style="position: absolute; top: 0; left: 0; right: 0; bottom: 40px;"
		></div>
		<div
			class="center"
			style="position: absolute; bottom: 0; left: 0; right: 0;"
		>
			<span class="dot bcPrimary"></span> {{ 'Tillgångar' | T }}
			<span class="dot bcTertiary"></span> {{ 'Skulder' | T }}
			<span class="dot bcLightGrey"></span> {{ 'Obeskattade reserver' | T }}
			<span class="dot result"></span> {{ 'Eget kapital' | T }}
		</div>
	</div>
</template>

<script>
/* tslint:disable */
import Highcharts from "highcharts";
import Vue from "vue";
import { colors } from "@/config";

export default {
	name: "D004",
	components: {},
	props: {
		overview: Array,
		balance: Array,
	},

	mounted() {
		this.chart = new Highcharts.chart({
			chart: {
				type: "column",
				renderTo: "d004",
				backgroundColor: "transparent",
			},

			credits: {
				enabled: false,
			},

			title: {
				text: "",
			},

			legend: {
				enabled: false,
			},

			colors: [
				...Array(3).fill(colors.Primary),
				...Array(3).fill(colors.Tertiary),
				colors.LightGrey,
				colors.Green,
				colors.Red,
			],

			xAxis: {
				categories: this.overview.map((o) => o.NAME),
				labels: {
					style: { fontSize: "1rem", color: colors.Black, },
				},
			},

			yAxis: {
				allowDecimals: false,
				title: {
					style: { fontSize: "1.2rem" },
					text: "%",
				},
				labels: {
					style: { fontSize: "1rem", color: colors.DarkGrey, },
				},
				tickPixelInterval: 150,
				gridLineColor: colors.LightGrey,
				plotLines: [{
					color: colors.Black,
					width: 2,
					value: 0,
					zIndex: 2,
				}]
			},

			tooltip: {
				formatter: function() {
					return (
						"<b>" +
						this.x +
						"</b><br/>" +
						this.series.name +
						": " +
						Vue.options.filters.TKR(this.y) +
						"<br>" +
						Vue.prototype.$t("Andel: ") +
						Vue.options.filters.D1(this.point.percentage) +
						" %"
					);
				},
				style: { fontSize: "1.25rem" },
				backgroundColor: colors.Light,
			},

			plotOptions: {
				column: {
					stacking: "percent",
					borderColor: colors.DarkGrey,
				},
			},

			series: [
				{
					name: Vue.prototype.$t("Tecknat, men ej inbetalt kapital"),
					data: this.balance.map((s) => s.A),
					stack: "tillgang",
				},
				{
					name: Vue.prototype.$t("Omsättningstillgångar"),
					data: this.balance.map((s) => s.K),
					stack: "tillgang",
				},
				{
					name: Vue.prototype.$t("Anläggningstillgångar"),
					data: this.balance.map((s) => s.E),
					stack: "tillgang",
				},
				{
					name: Vue.prototype.$t("Kortfristiga skulder"),
					data: this.balance.map((s) => s.Q),
					stack: "skuld",
				},
				{
					name: Vue.prototype.$t("Långfristiga skulder"),
					data: this.balance.map((s) => s.P),
					stack: "skuld",
				},
				{
					name: Vue.prototype.$t("Avsättningar"),
					data: this.balance.map((s) => s.O),
					stack: "skuld",
				},
				{
					name: Vue.prototype.$t("Obeskattade reserver"),
					data: this.balance.map((s) => s.N),
					stack: "skuld",
				},
				{
					name: Vue.prototype.$t("Eget kapital"),
					data: this.balance.map((s) => (s.M > 0 ? s.M : 0)),
					stack: "skuld",
				},
				{
					name: Vue.prototype.$t("Negativt eget kapital"),
					data: this.balance.map((s) => (s.M < 0 ? s.M : 0)),
					stack: "tillgang",
				},
			],
		});
	},
};
</script>

<style scoped lang="scss">
.dot {
	height: 20px;
	width: 20px;
	border-radius: 50%;
	display: inline-block;
}

.result {
	background: linear-gradient(
		-45deg,
		col("colors.Negative"),
		col("colors.Negative") 50%,
		col("colors.Positive") 50%
	);
	border-radius: 50%;
}

.center {
	font-size: 1.2rem;
}
</style>
